import { render, staticRenderFns } from "./choosewarehouse.vue?vue&type=template&id=0a75a906"
import script from "./choosewarehouse.vue?vue&type=script&lang=js"
export * from "./choosewarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports